export const platformList = [
    { code: 'desktop', name: 'lbl_login_desktop', abbreviation: 'd' },
    { code: 'mobile', name: 'lbl_login_mobile', abbreviation: 'm'},
    { code: 'downloadapp', name: 'lbl_DownloadApp' },
];

export const BDLoginPlatformList = [
    { code: 'desktop', name: 'lbl_Desktop' },
    { code: 'desktopCloud', name: 'Desktop Cloud' },
    { code: 'mobile', name: 'lbl_Mobile' },
    { code: 'CTCD', name: 'CTCD' },
];


export const LAYOUTTYPE = {
    HEADER:'header',
    RIGHTNAV:'rightNav',
    FOOTER:'footer'
}

export const LAYOUT_POSITIONS = {
    BEFORE_TOP: 'BeforeTop',
    BEFORE_FOOTER: 'BeforeFooter',
};

export const appDownloadPosition = [
    { layoutType: LAYOUTTYPE.HEADER, position: LAYOUT_POSITIONS.BEFORE_TOP },
    { layoutType: LAYOUTTYPE.RIGHTNAV, position: LAYOUT_POSITIONS.BEFORE_TOP },
    { layoutType: LAYOUTTYPE.FOOTER, position: LAYOUT_POSITIONS.BEFORE_FOOTER }
]

